// Función para formatear números con máximo 2 decimales y miles separados por puntos
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return value
  const num = parseFloat(value)
  const decimals = Math.round((num % 1) * 100) / 100
  const hasDecimals = decimals >= 0.1
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: hasDecimals ? 0 : 0,
    maximumFractionDigits: hasDecimals ? 0 : 0,
  })
}
